import "@albelli/arc-3/lib/menu.css";
import { vendor } from "helpers/vendorHelper";
import "polyfills/String​.prototype​.starts​With";
import { rawGET } from "services/httpService";
import { getAppConfig } from "./../services/configService";

const apiUrl = () => {
  return getAppConfig().PublicConf;
};

const getJson = async function(name) {
  const menu = await rawGET(null, `${apiUrl()}/${vendor}`);
  const text = await menu.text();
  if (text.startsWith("<")) {
    const fallback = await rawGET(null, `${apiUrl()}/bonusprint.co.uk`);
    return await fallback.json();
  }
  return JSON.parse(text);
};

export const getMenu = () => {
  return getJson("menu");
};
